import Util from "./_parts/Util.js";
import Scroll from "./_parts/Scroll.js";
import Menu from "./_parts/Menu.js";
import Slider from "./_parts/Slider.js";
import Mouse from "./_parts/Mouse.js";
import Tab from "./_parts/Tab.js";
import Filter from "./_parts/Filter.js";
import Resize from "./_parts/Resize.js";
import Cart from "./_parts/Cart.js";
import Customer from "./_parts/Customer.js";
import Toggle from "./_parts/Toggle.js";
import Modal from "./_parts/Modal.js";
//
import { gsap } from "./_parts/Util.js";

class App extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.common();
    this.swap();
    this.fadeIn();
    this.fadeOut();
  }

  fadeIn() {
    (function (d, callback) {
      var config = {
          kitId: "adq8zjg",
          scriptTimeout: 3000,
          async: true,
        },
        h = d.documentElement,
        t = setTimeout(function () {
          h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive";
        }, config.scriptTimeout),
        tk = d.createElement("script"),
        f = false,
        s = d.getElementsByTagName("script")[0],
        a;
      h.className += " wf-loading";
      tk.src = "https://use.typekit.net/" + config.kitId + ".js";
      tk.async = true;
      tk.onload = tk.onreadystatechange = function () {
        a = this.readyState;
        if (f || (a && a != "complete" && a != "loaded")) return;
        f = true;
        clearTimeout(t);
        try {
          Typekit.load(config);
          if (typeof callback === "function") callback();
        } catch (e) {}
      };
      s.parentNode.insertBefore(tk, s);
    })(document, function () {
      console.log("Typekit script loaded successfully.");

      gsap.to(document.body, {
        opacity: 1,
        duration: 0.4,
        delay: 0.4,
      });
    });
  }

  fadeOut() {
    document.querySelectorAll("a").forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        let blank = this.target === "_blank";

        if (!blank) {
          e.preventDefault();

          let href = this.getAttribute("href");
          gsap.to(document.body, {
            opacity: 0,
            duration: 0.2,
            onComplete: () => {
              location.href = href;
            },
          });
        }
      });
    });
  }

  swap() {
    if (!this.website.isDesktop) {
      const element = document.querySelector(".product-wrapper.case-study");
      if (element) {
        const spSwap = element.querySelector(".sp-none");
        spSwap.classList.add("sp-swap");
        spSwap.classList.remove("sp-none");
        element.insertBefore(spSwap, element.firstChild);
      }
    }
  }

  common() {
    if (window.location.pathname === "/pages/request-for-quote") {
      let section = document.querySelector(".grfq-main-page");
      section.classList.add("page-request-for-quote");
    }

    window.SCROLL_INSTANCE = new Scroll();
    window.MENU_INSTANCE = new Menu();
    window.SLIDER_INSTANCE = new Slider();
    window.MOUSE_INSTANCE = new Mouse();
    window.TAB_INSTANCE = new Tab();
    window.FILTER_INSTANCE = new Filter();
    window.RESIZE_INSTANCE = new Resize();
    window.CART_INSTANCE = new Cart();
    window.CUSTOMER_INSTANCE = new Customer();
    window.TOGGLE_INSTANCE = new Toggle();
    window.SIZE_MODAL_INSTANCE = new Modal();

    window.addEventListener("popstate", function (event) {
      location.reload();
      console.log("popstate");
    });

    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        console.log("履歴キャッシュから復元されました");
        location.reload();
      }
    });
  }
}

gsap.delayedCall(0.1, () => {
  window.APP_INSTANCE = new App();
});

export default App;
